import { Box, ButtonNew, Text } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { Colors, getFutureDay, getPastDay, setToDateTime } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import CalendarView from './CalenderView'
import styles from './styles'
import { CalendarProps, CalendarTypes, CalendarTypesOption } from './types'

const cancelBtnLabel = 'Cancel'

const get180DaysAgo = (date: Date): Date => {
  const nDate = new Date(date).getTime() - 180 * 24 * 60 * 60 * 1000
  return new Date(nDate)
}

const get180thDayFromToday = (date: Date): Date => {
  const nDate = new Date(date).getTime() + 180 * 24 * 60 * 60 * 1000
  return new Date(nDate)
}

const getOneYearAfter = (date: Date): Date => {
  const nDate = new Date(date)
  if (date.getDate() === 29 && date.getMonth() === 1) {
    nDate.setDate(28)
  }
  nDate.setFullYear(nDate.getFullYear() + 1)
  return nDate
}

const Calendar: FC<CalendarProps> = ({
  ID,
  onDateSelected,
  holidayList,
  type,
  onCancel,
  defaultMinDate,
  defaultMaxDate,
  maxDuration,
  scrollToCurrentDate,
  sendError,
}: CalendarProps) => {
  // const type = type //|| props.navigation.getParam('type', CalendarTypes.HISTORY)
  // const onDateSelected = onDateSelected //|| props.navigation.getParam('onDateSelected')

  const [firstDate, setFirstDate] = useState<Date>()
  const [secondDate, setSecondDate] = useState<Date>()
  const [refreshFlag, setRefreshFlag] = useState<boolean>(false)
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0)
  const today = new Date(currentDate)
  // const oneYearAgo = getOneYearAgo(today)
  const _180DaysAgo = get180DaysAgo(today)
  const oneYearAfter = getOneYearAfter(today)
  const _180DaysFuture = get180thDayFromToday(today)

  const getDate = (): Date => {
    if (type === CalendarTypes.HISTORY) {
      if (maxDuration && !!firstDate) {
        return _180DaysAgo > getPastDay(firstDate, maxDuration) ? _180DaysAgo : getPastDay(firstDate, maxDuration)
      }
      return _180DaysAgo
    }
    if (type === CalendarTypes.SINGLE) {
      return _180DaysAgo
    }
    return today
  }
  const minDate = defaultMinDate ? new Date(defaultMinDate) : getDate()

  const maxDate = defaultMaxDate
    ? firstDate && maxDuration
      ? defaultMaxDate < getFutureDay(firstDate, maxDuration)
        ? defaultMaxDate
        : getFutureDay(firstDate, maxDuration)
      : defaultMaxDate
    : type === CalendarTypes.HISTORY
      ? maxDuration && !!firstDate
        ? today < getFutureDay(firstDate, maxDuration)
          ? today
          : getFutureDay(firstDate, maxDuration)
        : today
      : CalendarTypes.SINGLE_FUTURE
        ? _180DaysFuture
        : oneYearAfter
  const internalOnDateSelected = (date: Date): void => {
    if (type === CalendarTypes.SINGLE || type === CalendarTypes.SINGLE_FUTURE) {
      onDateSelected(date)
      return
    }
    if (firstDate) {
      if (secondDate) {
        if (maxDuration) {
          const duration = (date.getTime() - secondDate.getTime()) / (24 * 60 * 60 * 1000)
          if (Math.abs(duration) <= maxDuration) {
            setFirstDate(secondDate)
            setSecondDate(date)
          } else {
            sendError && sendError('You can select date range upto 31 days only.')
            return
          }
        } else {
          setFirstDate(secondDate)
          setSecondDate(date)
        }
      } else {
        if (type === CalendarTypes.HISTORY) {
          if (firstDate < date) {
            onDateSelected(firstDate, setToDateTime(date))
          } else {
            onDateSelected(date, setToDateTime(firstDate))
          }
        } else {
          onDateSelected(firstDate, date)
        }
        setFirstDate(undefined)
        setRefreshFlag((cFlag) => !cFlag)
        return
      }
      return
    }
    setFirstDate(date)
    onDateSelected(date)
    setRefreshFlag((cFlag) => !cFlag)
  }
  useEffect(() => {
    setFirstDate(undefined)
    setSecondDate(undefined)
    setRefreshFlag((cFlag) => !cFlag)
  }, [type, holidayList])
  const preSelectedDate = type === CalendarTypes.SINGLE ? today : firstDate
  return (
    <>
      <CalendarView
        ID={`${ID}.CalendarView`}
        type={type}
        minDate={minDate}
        maxDate={maxDate}
        onDateSelected={internalOnDateSelected}
        holidayList={holidayList}
        refreshFlag={refreshFlag}
        preSelectedDate={preSelectedDate}
        secondSelectedDate={secondDate}
        maxDuration={maxDuration}
        scrollToCurrentDate={scrollToCurrentDate}
      />
      <Box {...styles[type].btnsContainer} justifyContent={maxDuration ? 'space-between' : 'flex-end'}>
        <ModBox show={!!maxDuration} flexDirection={'row'} align={'center'}>
          <Box bg={Colors.WASHED_YELLOW_LIGHT}>
            <Text title={'NOTE'} fontFamily={'jiotype-bold'} fontSize={12} />
          </Box>
          <Text title={' : You can select date range upto 31 days only.'} fontFamily={'jiotype-medium'} fontSize={12} />
        </ModBox>
        <Box flexDirection={'row'} justify={'center'}>
          <ButtonNew
            testID="cancel-calendar-modal"
            title={cancelBtnLabel}
            type={'custom'}
            color={'#FFFFFF'}
            hoverColor={'BRAND_COLOR_GRAY_6'}
            underlayColor={'BRAND_COLOR_GRAY_5'}
            borderColor={'transparent'}
            borderRadius={'5px'}
            titleColor={'grey'}
            shadowType={'shadowSecondary'}
            onPress={onCancel}
          />
        </Box>
      </Box>
    </>
  )
}

export { CalendarTypes, CalendarTypesOption }
export default Calendar
